import { mapState, mapGetters, mapActions } from 'vuex'

export const feedbackComputed = {
  ...mapState('feedback', {
    loading: (state) => state.loading,
  }),
  ...mapGetters('feedback', ['getStatus', 'getErrors']),
}

export const feedbackMethods = mapActions('feedback', [
  'registrationFeedback',
  'resetFeedback',
])
